import {inject, Injectable} from '@angular/core';
import {AbstractSandbox} from '../../../core/sandboxes/abstract.sandbox';
import {HomeMarketBonus, HomeMarketBonusQuery} from '../../../core/interfaces/home-market-bonus.interface';
import {HomeMarketBonusRestService} from '../../../core/services/rest/home-market-bonus.rest.service';
import moment from 'moment';
import {util} from '../../../core/util/util';
import {combineLatest, shareReplay, switchMap} from 'rxjs';
import {filter, map} from "rxjs/operators";
import {Definition} from '../../../core/store/definitions/definition.interface';

function sortedShipTos<T extends Definition[] | undefined>(definitions: T): T {
  if (definitions) {
    const clone: Definition[] = [...definitions];
    // @ts-ignore
    return clone.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  }
  return definitions;
}

@Injectable({providedIn: 'root'})
export class HomeMarketBonusSandbox extends AbstractSandbox {

  private homeMarketBonusRestService = inject(HomeMarketBonusRestService);
  private shipTos$ = this.store.select(state => state.customerInfo).pipe(
    filter(customer => !!customer.customer),
    switchMap(() => this.homeMarketBonusRestService.getHomeMarketBonusShipTos$()),
    shareReplay(1)
  );
  shipTosLoading$ = this.shipTos$.pipe(map(r => r.loading));
  senderShipTos$ = this.shipTos$.pipe(map(shipTos => sortedShipTos(shipTos?.senderShipTos)));
  receiverShipTos$ = this.shipTos$.pipe(map(shipTos => sortedShipTos(shipTos?.receiverShipTos)));
  loadingShipTosFailed$ = this.shipTos$.pipe(map(shipTos => shipTos?.failed));
  noHmbRecordsAvailable$ = combineLatest([this.shipTos$, this.shipTosLoading$]).pipe(
    map(([shipTos, isLoading]) => {
      return !isLoading && shipTos && !shipTos?.failed && shipTos.senderShipTos?.length === 0 && shipTos.receiverShipTos?.length === 0;
    }),
    shareReplay(1),
  );

  getHomeMarketBonuses(query: HomeMarketBonusQuery): Promise<HomeMarketBonus[]> {
    return this.homeMarketBonusRestService.getHomeMarketBonuses$(query);
  }

  downloadHomeMarketBonuses(query: HomeMarketBonusQuery): void {
    this.homeMarketBonusRestService.downloadHomeMarketBonuses$(query).subscribe((result: Blob) => {
      const timestamp = moment().format('YYYYMMDDHHmmss');
      util.openBlob(result, `home-market-bonus-records-${timestamp}.xlsx`);
    });

  }
}
